export default "__VITE_ASSET__BfOY22ZO__"